export const SIGNIN_REQUEST = "@AUTH/SIGNIN_REQUEST";
export const SIGNIN_SUCCESS = "@AUTH/SIGNIN_SUCCESS";
export const SIGNIN_FAILURE = "@AUTH/SIGNIN_FAILURE";

export const REFRESH_SUCCESS = "@AUTH/REFRESH_SUCCESS";

export const LOGOUT = "@AUTH/LOGOUT";
